import React from "react";
import {cx} from "../../lib/ClassSet";

const Address = (props) => {

  let address = props.address;
  if (address.get("name") == null) return null;
  let classes = cx({
    "Address": true,
    "u-inline": props.inline,
    "u-addressLine2": address.get("addressAddressLine2", "").length > 0,
    "u-email": address.get("email", "").length > 0,
    "u-attName": address.get("attName", "").length > 0,
    "u-phoneNr": address.get("phoneNr", "").length > 0
  })

  return (
    <div className={classes}>
      <div className="type">{address.get("type", "")}</div>
      <div className="name">{address.get("name", "")}</div>
      <div className="att">Attn. {address.get("attName", "")}</div>
      <div className="phoneNr">Phone Nr. {address.get("phoneNr", "")}</div>
      <div className="email">{address.get("email", "")}</div>
      <div>
        {address.get("addressAddressLine1", "")}
        <span className="addressLine2">, {address.get("addressAddressLine2", "")}</span>
        , {address.get("addressCity", "")}
        , {address.get("addressStateProvince", "")}
        , {address.get("addressPostcode", "")}
        , {address.get("addressCountryName", "")}
      </div>
    </div>
  )
}

Address.defaultProps = {
  inline: false
}

export default Address;